import {motion} from 'framer-motion';
import {useState} from 'react';
import {Chip,Box} from '@mui/material';

const BlogCard=({post})=>{
  const [hovered,setHovered]=useState(false);
  const cat=post.categories?.[0];
  const displayImage=post.featured_image||'https://source.unsplash.com/800x600?tech';
  const isDark = document.documentElement.classList.contains('dark'); // simple detección

  return(
    <motion.div
      whileHover={{scale:1.03,rotateZ:.5}}
      transition={{type:'spring',stiffness:300}}
      onHoverStart={()=>setHovered(true)}
      onHoverEnd={()=>setHovered(false)}
      onClick={()=>window.location.href=post.isExternal?`/news/${post.id}`:`/blog/${post.slug}`}
      style={{
        background:`linear-gradient(135deg,rgba(0,245,255,.1) 0%,rgba(255,0,193,.1) 100%)`,
        border:'1px solid rgba(0,245,255,.3)',
        borderRadius:16,
        boxShadow:hovered?'0 12px 40px rgba(255,0,193,.3)':'0 8px 32px rgba(0,245,255,.2)',
        overflow:'hidden',cursor:'pointer',position:'relative'
      }}
    >
      <div style={{position:'relative',height:200}}>
        <img src={displayImage} alt={post.title} style={{width:'100%',height:'100%',objectFit:'cover'}}/>
        <div style={{position:'absolute',inset:0,background:'linear-gradient(180deg,transparent 0%,rgba(0,0,0,.8) 100%)'}}/>
      </div>
      <div style={{padding:16}}>
        <Chip label={cat?.name} sx={{background:`linear-gradient(90deg,#00F5FF,#FF00C1)`,color:'#000',fontWeight:800,fontSize:'0.7rem'}}/>
        <h3 style={{color:isDark?'#00F5FF':'#FF3FA3',margin:'12px 0',fontSize:'1.2rem',fontWeight:700}}>
          {post.title}
        </h3>
        <p style={{color:isDark?'#A0A0A0':'#4A4A4A',fontSize:'0.9rem',lineHeight:1.4}}>
          {post.excerpt?.substring(0,100)}...
        </p>
      </div>
      {hovered&&(
        <motion.div initial={{opacity:0,y:20}} animate={{opacity:1,y:0}}
          style={{position:'absolute',bottom:16,right:16,background:'#00F5FF',color:'#000',padding:'8px 12px',borderRadius:8,fontWeight:800,fontSize:'0.8rem'}}
        >Leer Artículo →</motion.div>
      )}
    </motion.div>
  );
};
export default BlogCard;
